export default __webpack_public_path__ + "static/media/cavity.141355e0.svg";